import React, { createContext, useContext, useState } from 'react';
import { IProviderProps } from '../@types/ContextProviderRelated';
import { IHistoryEntry } from '../hooks/useUndoRedo';

interface IHistoryContext {
  currentIndex: number | undefined;
  history: Array<IHistoryEntry>;
  isDebouncing: boolean;
  setHistory: (newHistory: Array<IHistoryEntry>) => void;
  setCurrentIndex: (value: number | undefined) => void;
  setIsDebouncing: (value: boolean) => void;
}

export const HistoryContext = createContext<IHistoryContext | undefined>(undefined);

export const useHistory = () => {
  const context = useContext(HistoryContext);
  if (!context) {
    throw new Error('useHistory must be used within a HistoryProvider');
  }
  return context;
};

export function HistoryProvider({ children }: IProviderProps): JSX.Element {
  const [currentIndex, setCurrentIndex] = useState<number | undefined>(undefined);
  const [history, setHistory] = useState<Array<IHistoryEntry>>([]);
  const [isDebouncing, setIsDebouncing] = useState<boolean>(false);

  return (
    <HistoryContext.Provider
      value={{
        currentIndex,
        history,
        isDebouncing,
        setCurrentIndex,
        setHistory,
        setIsDebouncing,
      }}
    >
      {children}
    </HistoryContext.Provider>
  );
}
